import BaseComponent from "../../common/BaseComponent";
const timeOutMins = 20;
class ControlPageBehavior extends BaseComponent {
  constructor(props: any) {
    super(props);
    // @ts-ignore
    this.overTime = 20;
    // @ts-ignore
    this.ele = null;
    // @ts-ignore
    this.method = () => {
      // empty function
    };
  }
  resetOverTime = () => {
    // @ts-ignore
    clearInterval(this.timer);
    // @ts-ignore
    this.overTime = 20;
    // @ts-ignore
    this.resetListener(this.ele, this.method);
  };

  resetListener = (ele: any, method: any) => {
    // @ts-ignore
    this.ele = ele;
    // @ts-ignore
    this.method = method;
    // @ts-ignore
    this.timer = setInterval(() => {
      // @ts-ignore
      this.overTime -= 1;
      // @ts-ignore
      if (this.overTime === 0) {
        method();
      }
    }, 60000);
  };

  clearListener = () => {
    // @ts-ignore
    clearInterval(this.timer);
    // @ts-ignore
    this.overTime = 20;
  };

  addEleListener = (ele: any) => {
    ele.addEventListener("dbclick", () => {
      this.resetOverTime();
    });
    ele.addEventListener("mousedown", () => {
      this.resetOverTime();
    });
    ele.addEventListener("keydown", () => {
      this.resetOverTime();
    });
    ele.addEventListener("keypress", () => {
      this.resetOverTime();
    });
  };
}

// @ts-ignore
const controlPageBehavior = new ControlPageBehavior();
export default controlPageBehavior;
export { ControlPageBehavior, timeOutMins };
